<ng-container *ngIf="bannerVisible">
  <goab-notification class="notification-body" type="important" (onDismiss)="handleDismiss()">{{
    formattedBannerMessage
  }}</goab-notification>
</ng-container>
